import type { BridgeToApiHeartbeatMessage } from '../../types/bridge-to-api-messages.js';

export function buildBridgeHeartbeatMessage(
  seq: number,
  meanRttMs: number | undefined,
): BridgeToApiHeartbeatMessage {
  return meanRttMs !== undefined && Number.isFinite(meanRttMs)
    ? { t: 'h', s: seq, m: Math.round(meanRttMs) }
    : { t: 'h', s: seq };
}
